import { RouteType } from "types/RouteType";
import dashboardRoute from "./Dashboard/AccountingDashboard.Route";
import taxLookupRoute from "./tax-lookup/TaxLookup.Route";
import plantOverviewRoute from "./PlantOverview/PlantOverview.Route";

// Purchase Order Management (spec 02-purchase-order-management.md)
import purchaseOrdersRoute from "./PurchaseOrders/PurchaseOrders.Route";

// Task/Approval Workflow (spec 03-task-approval-workflow.md)
import taskWorkflowRoute from "./TaskWorkflow/TaskWorkflow.Route";

// Invoice Management (spec 06-invoice-management.md)
import invoicesRoute from "./Invoices/Invoices.Route";

// Accounts Payable (spec 07-accounts-payable.md)
import accountsPayableRoute from "./AccountsPayable/AccountsPayable.Route";

// Accounts Receivable (spec 08-accounts-receivable.md)
import accountsReceivableRoute from "./AccountsReceivable/AccountsReceivable.Route";

// Freight Matching (Implementation Plan Phase 1)
import freightMatchingRoute from "./FreightMatching/FreightMatching.Route";

// Asset Transactions (Implementation Plan Phase 1 - GL Controls)
import assetTransactionsRoute from "./AssetTransactions/AssetTransactions.Route";

// Check Printing (Implementation Plan Phase 1)
import checkPrintingRoute from "./CheckPrinting/CheckPrinting.Route";
import checkTemplateDesignerRoute from "./CheckTemplateDesigner/CheckTemplateDesigner.Route";

// Recurring Transactions (Phase 3)
import recurringTransactionsRoute from "./RecurringTransactions/RecurringTransactions.Route";

// Fiscal Periods (Phase 5)
import fiscalPeriodsRoute from "./FiscalPeriods/FiscalPeriods.Route";

// Custom Report Builder (Phase 5)
import reportBuilderRoute from "./Reports/ReportBuilder/ReportBuilder.Route";

// General Ledger (GL Implementation Plan)
import generalLedgerRoute from "./GeneralLedger/GeneralLedger.Route";

// Account Reconciliation (GL Implementation Plan)
import reconciliationRoute from "./Reconciliation/Reconciliation.Route";

// Chart of Accounts (GL Implementation Plan)
import chartOfAccountsRoute from "./ChartOfAccounts/ChartOfAccounts.Route";

const accountingRoutesList: RouteType[] = [
  dashboardRoute,
  taxLookupRoute,
  plantOverviewRoute,
  // Purchase Order Management (spec 02)
  purchaseOrdersRoute,
  // Task/Approval Workflow (spec 03)
  taskWorkflowRoute,
  // Invoice Management (spec 06)
  invoicesRoute,
  // Accounts Payable (spec 07)
  accountsPayableRoute,
  // Accounts Receivable (spec 08)
  accountsReceivableRoute,
  // Freight Matching (Implementation Plan Phase 1)
  freightMatchingRoute,
  // Asset Transactions (Implementation Plan Phase 1 - GL Controls)
  assetTransactionsRoute,
  // Check Printing (Implementation Plan Phase 1)
  checkPrintingRoute,
  checkTemplateDesignerRoute,
  // Recurring Transactions (Phase 3)
  recurringTransactionsRoute,
  // Fiscal Periods (Phase 5)
  fiscalPeriodsRoute,
  // Custom Report Builder (Phase 5)
  reportBuilderRoute,
  // General Ledger (GL Implementation Plan)
  generalLedgerRoute,
  // Account Reconciliation (GL Implementation Plan)
  reconciliationRoute,
  // Chart of Accounts (GL Implementation Plan)
  chartOfAccountsRoute,
];

export default accountingRoutesList;
